// TODO: rename: "DisabilityAndUnpaidCare"
import { HorizontalBar, Bar, Line } from "react-chartjs-2";
import createChartComponentsForDiagramConfigs from "./CaptionTableChartComponent.js";
import Tables from "Components/Tables/Other";
import GenericTable from "Components/Tables/GenericTable";
import Captions from "Captions";
import { sortAgeGroups } from "Lookups";
import round from "Utils/round";
import config from "Config";

const DiagramData = {
  "Disability": {
    ChartComponent: Bar,
    chartOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    },
    TableComponent: Tables["Disability"] || GenericTable,
    queries: ["CATEGORY_DISABILITY"],
    // missingFor2016: true,
    captionDataDerive: _data =>
      ({}.tap(data => {
        data.total_count = _data.datasets[0].data.reduce(
          (sum, amount, index) => sum + amount + _data.datasets[1].data[index],
          0
        );
        data.total_perc = round(1)(
          data.total_count /
            ((_data.total_population - _data.total_population_na) / 100)
        );

        data.total_count_state = _data.rows_state.reduce(
          (sum, { number }) => sum + number,
          0
        );

        data.total_perc_state = round(1)(
          data.total_count_state /
            ((_data.total_population_state - _data.total_population_na) / 100)
        );

        data.male_pct = round(1)(
          _data.datasets[0].data.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ) /
            (data.total_count / 100)
        );

        data.female_pct = round(1)(
          _data.datasets[1].data.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ) /
            (data.total_count / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }]
      },
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }]
      },
      {
        rows: [{ number: total_population_na }]
      }
    ]) => ({
      labels: [...new Set(rows.map(r => r["broadage10"]))],
      datasets: [
        {
          label: "Male",
          backgroundColor: config.primary_chart_color,
          data: rows.filter(r => r["sexp_sex"] == "Male").map(r => r["number"])
        },
        {
          label: "Female",
          backgroundColor: config.secondary_chart_color,
          data: rows
            .filter(r => r["sexp_sex"] == "Female")
            .map(r => r["number"])
        }
      ],
      total_population,
      total_population_state,
      rows_state,
      total_population_na,
      table: {
        rows,
        fields,
        name: "Disability",
        sortFunc: {
          broadage10: sortAgeGroups(
            "broadage10"
          )
        }
      }
    })
  },
  "Unpaid Care": {
    ChartComponent: Bar,
    chartOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    },
    TableComponent: Tables["Unpaid Care"] || GenericTable,
    queries: ["CATEGORY_UNPAID_CARE"],
    // missingFor2016: true,
    captionDataDerive: _data =>
      ({}.tap(data => {
        data.total_count = _data.datasets[0].data.reduce(
          (sum, amount, index) => sum + amount + _data.datasets[1].data[index],
          0
        );
        data.total_perc = round(1)(
          data.total_count /
            ((_data.total_population) / 100)
        );

        data.total_count_state = _data.rows_state.reduce(
          (sum, { number }) => sum + number,
          0
        );

        data.total_perc_state = round(1)(
          data.total_count_state /
            ((_data.total_population_state) / 100)
        );

        data.male_pct = round(1)(
          _data.datasets[0].data.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ) /
            (data.total_count / 100)
        );

        data.female_pct = round(1)(
          _data.datasets[1].data.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ) /
            (data.total_count / 100)
        );
      })),
    dataPipeline: () => ([
      { rows, fields },
      {
        rows: [{ number: total_population }]
      },
      { rows: rows_state },
      {
        rows: [{ number: total_population_state }]
      },
      {
        rows: [{ number: total_population_na }]
      }
    ]) => ({
      labels: [...new Set(rows.map(r => r["workage10"]))],
      total_population,
      total_population_state,
      rows_state,
      total_population_na,
      datasets: [
        {
          label: "Males providing unpaid assistance",
          backgroundColor: config.primary_chart_color,
          data: rows.filter(r => r["sexp_sex"] == "Male").map(r => r["number"])
        },
        {
          label: "Females providing unpaid assistance",
          backgroundColor: config.secondary_chart_color,
          data: rows
            .filter(r => r["sexp_sex"] == "Female")
            .map(r => r["number"])
        }
      ],
      table: {
        rows,
        fields,
        name: "Unpaid Care",
        hide_fields: ["uncarep_unpaid_assistance_to_a_person_with_a_d"]
      }
    })
  }
}.tap(diagrams =>
  Object.keys(Captions["Disability and Unpaid Care"]).forEach(
    key => (diagrams[key].captions = Captions["Disability and Unpaid Care"][key])
  )
);

export default createChartComponentsForDiagramConfigs(DiagramData);



// WEBPACK FOOTER //
// ./components/Charts/Other.js